import { type DOIControlledTerm } from './utils/doi';

export function ControlledTerm({ term }: { term: DOIControlledTerm }) {
  return (
    <div>
      {term.uri ? (
        <a href={term.uri} target="_blank" rel="noopener noreferrer">
          {term.name}
        </a>
      ) : (
        term.name
      )}
      {term.scheme && <span className="text-muted"> ({term.scheme})</span>}
    </div>
  );
}
